export default "__VITE_ASSET__DbePBmB7__"